(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var H = window.H24 || {};

  function money(cents) {
    var v = (cents / 100).toFixed(2).split('.');
    var amount = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
    return amount + ' €';
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* Toast */
  var toastTimer;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-show');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-show'); }, 2600);
  }

  /* Sticky header shadow */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 12); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Mobile menu */
  var mm = $('[data-mobile-menu]');
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { mm.classList.add('is-open'); mm.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { mm.classList.remove('is-open'); mm.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }); });

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else { $$('.reveal').forEach(function (el) { el.classList.add('is-visible'); }); }

  /* ---------- Cart drawer ---------- */
  var drawer = $('#cart-drawer'), overlay = $('[data-drawer-overlay]');
  function openCart() { if (!drawer) return; renderCart(); drawer.classList.add('is-open'); overlay.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeCart() { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  $$('[data-cart-open]').forEach(function (a) { a.addEventListener('click', function (e) { if (document.body.classList.contains('template-cart')) return; e.preventDefault(); openCart(); }); });
  if (overlay) overlay.addEventListener('click', closeCart);
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { if (drawer && drawer.classList.contains('is-open')) closeCart(); closeSearch(); } });

  function setCount(n) { $$('[data-cart-count]').forEach(function (c) { c.textContent = n; c.hidden = n === 0; }); }

  function renderCart(cart) {
    var p = cart ? Promise.resolve(cart) : fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    return p.then(function (c) {
      setCount(c.item_count);
      var body = $('[data-cart-body]'), foot = $('[data-cart-foot]');
      if (!body) return c;
      if (c.item_count === 0) {
        body.innerHTML = '<div class="empty" style="border:0;padding:4rem 0"><h2>Dein Warenkorb ist leer</h2><p>Entdecke unsere authentischen Produkte aus Marokko.</p><a href="/collections/all" class="btn btn--primary">Jetzt einkaufen</a></div>';
        foot.hidden = true; return c;
      }
      var remaining = Math.max(0, (H.freeShipping || 6000) - c.total_price);
      var pct = Math.min(100, Math.round(c.total_price / (H.freeShipping || 6000) * 100));
      var html = '<div class="ship-bar"><span>' + (remaining > 0 ? 'Noch <strong>' + money(remaining) + '</strong> bis zum kostenlosen Versand' : '<strong>Du erhältst kostenlosen Versand!</strong>') + '</span><div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div></div>';
      c.items.forEach(function (it, i) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
        html += '<div class="line"><a href="' + it.url + '" class="line__img">' + (img ? '<img src="' + img + '" alt="">' : '') + '</a><div class="line__info">' +
          '<a href="' + it.url + '" class="line__title">' + esc(it.product_title) + '</a>' +
          (it.product_has_only_default_variant ? '' : '<span class="line__variant">' + esc(it.variant_title) + '</span>') +
          '<div class="line__row"><div class="qty"><button type="button" data-line-qty="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Weniger">−</button><input type="number" value="' + it.quantity + '" readonly aria-label="Menge"><button type="button" data-line-qty="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Mehr">+</button></div>' +
          '<span class="line__price">' + money(it.final_line_price) + '</span></div>' +
          '<button type="button" class="line__remove" data-line-qty="' + (i + 1) + '" data-q="0" style="align-self:flex-start">Entfernen</button></div></div>';
      });
      body.innerHTML = html;
      $('[data-cart-subtotal]').textContent = money(c.total_price);
      foot.hidden = false;
      return c;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-qty]'); if (!b) return;
    b.disabled = true;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +b.dataset.lineQty, quantity: Math.max(0, +b.dataset.q) }) })
      .then(function (r) { return r.json(); }).then(function (c) { renderCart(c); });
  });

  function addToCart(id, qty, title) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { toast((title || 'Produkt') + ' wurde zum Warenkorb hinzugefügt.'); openCart(); })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Konnte nicht hinzugefügt werden.'); });
  }

  /* Quick add on cards */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick-add]'); if (!q) return;
    e.preventDefault(); e.stopPropagation();
    addToCart(q.dataset.quickAdd, 1, q.dataset.title);
  });

  /* ---------- Product page ---------- */
  var root = $('[data-product-root]');
  if (root) {
    var data = JSON.parse($('[data-product-json]', root).textContent);
    var form = $('[data-product-form]', root);
    var idInput = $('[data-variant-id]', root);
    var mainImgWrap = $('[data-gallery-main]', root);
    var title = ($('h1', root) || {}).textContent;

    function showImage(src, mediaId) {
      var img = $('img', mainImgWrap);
      if (img && src) { img.removeAttribute('srcset'); img.src = src; }
      $$('[data-thumb]', root).forEach(function (t) { t.classList.toggle('is-active', String(t.dataset.mediaId) === String(mediaId)); });

    }
    /* zoom on hover (desktop) */
    if (mainImgWrap && window.matchMedia('(hover:hover)').matches) {
      mainImgWrap.addEventListener('mousemove', function (e) {
        var img = $('img', mainImgWrap); if (!img) return;
        var r = mainImgWrap.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        img.style.transform = 'scale(1.8)';
      });
      mainImgWrap.addEventListener('mouseleave', function () { var img = $('img', mainImgWrap); if (img) img.style.transform = ''; });
    }

    var selected = $$('.opt', root).map(function (o) { var a = $('.opt__btn.is-active', o); return a ? a.dataset.optValue : null; });
    function findVariant() { return data.variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); }); }
    function updateUnavailable() {
      $$('.opt__btn', root).forEach(function (b) {
        var idx = +b.dataset.optIndex, test = selected.slice(); test[idx] = b.dataset.optValue;
        var ok = data.variants.some(function (v) { return v.available && v.options.every(function (o, i) { return o === test[i]; }); });
        b.classList.toggle('is-unavailable', !ok);
      });
    }
    function applyVariant(v) {
      if (!v) return;
      idInput.value = v.id;
      var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      var pw = $('[data-price-wrap]', root);
      var on = v.compare > v.price;
      pw.innerHTML = '<div class="price price--lg"><span class="price__now">' + money(v.price) + '</span>' + (on ? '<span class="price__was">' + money(v.compare) + '</span><span class="price__pct">−' + Math.round((v.compare - v.price) / v.compare * 100) + '%</span>' : '') + '</div>';
      $('[data-buy-row]', root).hidden = !v.available;
      $('[data-soldout]', root).hidden = v.available;
      var note = $('[data-stock-note]', root);
      note.textContent = (v.available && v.tracked === 'shopify' && v.qty > 0 && v.qty <= 5) ? 'Nur noch ' + v.qty + ' Stück verfügbar' : '';
      if (v.media && v.src) showImage(v.src, v.media);
    }
    $$('.opt__btn', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var idx = +b.dataset.optIndex;
        selected[idx] = b.dataset.optValue;
        $$('.opt__btn[data-opt-index="' + idx + '"]', root).forEach(function (x) { x.classList.toggle('is-active', x === b); });
        var lab = $('[data-opt-selected="' + idx + '"]', root); if (lab) lab.textContent = b.dataset.optValue;
        applyVariant(findVariant()); updateUnavailable();
      });
    });
    updateUnavailable();

    var qty = $('[data-qty-input]', root);
    if (qty) {
      $('[data-qty-minus]', root).addEventListener('click', function () { qty.value = Math.max(1, (+qty.value || 1) - 1); });
      $('[data-qty-plus]', root).addEventListener('click', function () { qty.value = (+qty.value || 1) + 1; });
    }
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[data-add-btn]', root); btn.disabled = true;
      addToCart(idInput.value, Math.max(1, +qty.value || 1), title).then(function () { btn.disabled = false; });
    });
  }

  /* Related products (async) */
  $$('[data-related-url]').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.dataset.relatedUrl).then(function (r) { return r.text(); }).then(function (t) {
      var d = document.createElement('div'); d.innerHTML = t;
      var inner = d.querySelector('[data-related-url]');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    });
  });

  /* ---------- Collection: sort & filters ---------- */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u; });
  var ff = $('[data-filter-form]');
  if (ff) {
    $$('[data-filter-check]', ff).forEach(function (c) { c.addEventListener('change', function () { ff.requestSubmit ? ff.requestSubmit() : ff.submit(); }); });
    ff.addEventListener('submit', function (e) {
      e.preventDefault();
      var params = new URLSearchParams(new FormData(ff));
      Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
      location.search = params.toString();
    });
  }
  var ft = $('[data-filter-toggle]');
  if (ft) ft.addEventListener('click', function () { $('[data-filters]').classList.toggle('is-open'); });

  /* ---------- Predictive search ---------- */
  var sd = $('#search-dialog'), si = $('[data-search-input]'), sr = $('[data-search-results]'), st;
  function closeSearch() { if (sd) sd.classList.remove('is-open'); }
  $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', function () { sd.classList.add('is-open'); setTimeout(function () { si.focus(); }, 30); }); });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', closeSearch); });
  if (sd) sd.addEventListener('click', function (e) { if (e.target === sd) closeSearch(); });
  if (si) si.addEventListener('input', function () {
    clearTimeout(st);
    var q = si.value.trim();
    if (q.length < 2) { sr.innerHTML = ''; return; }
    st = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
          sr.innerHTML = ps.length ? ps.map(function (p) {
            return '<a class="search-hit" href="' + p.url + '">' + (p.image ? '<img src="' + p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="">' : '<span style="width:3rem"></span>') + '<span>' + esc(p.title) + '<br><strong class="price__now" style="font-size:.875rem">' + esc(p.price) + ' €</strong></span></a>';
          }).join('') : '<p class="small" style="padding:1rem">Keine Produkte gefunden.</p>';
        });
    }, 200);
  });
})();
